import React from 'react'
import { RiAddCircleLine } from "react-icons/ri"
import { Link } from 'react-router-dom';
import Nav from '../Nav/Nav';

import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../../api/api';
import { toast } from "react-toastify"

const ADDAudio_URL = "api/audio/addaudio"

function AddAudio() {

    const [audiotitle, Setaudiotitle] = useState("");
    const [audiotype, Setaudiotype] = useState("");
    const [audiofile, Setaudiofile] = useState();
    const [loading, Setloading] = useState(false);
    const navigate = useNavigate();

    document.title = "Add Audio-Jain Sadhana"

    const HandleAdd = async (event) => {
        Setloading(true)
        event.preventDefault();
        const data = new FormData();
        data.append('audiotitle', audiotitle);
        data.append('audiotype', audiotype);
        data.append('audiofile', audiofile);

        try {
            const response = await axios.post(ADDAudio_URL, data)
            if (response.status === 200) {
                navigate('/menu/audiolist')
                toast.success('Audio Added Successfully')
                Setloading(false)

            }
        } catch (error) {
            console.log(error?.response?.data?.message)
            setTimeout(()=>Setloading(false),1000)
        }

    }



    return (
        <div className="container-fluid mt-3">
            <div className="row me-auto w-100">
                <div className="col-lg-3 px-4">
                    <Nav TaskTitleClass="active" audio="text-white" />
                </div>
                <div className="col-lg-9">
                    <div className='font '>

                        {/* section 2 */}
                        <div className='container-fluid content-list-main-box mb-5' >
                            <div className=' position-relative content-box' >
                                <div className='d-flex mb-3 justify-content-between align-item-center' >
                                    <p className='list-page-title text-black'  >Add New Audio</p>
                                    <Link to="/menu/audiolist" className='text-black btn button-yellow  back-list-button'>
                                        <i className='me-2' ><RiAddCircleLine /></i> List All Audio</Link>
                                </div>
                                <div>
                                    <form onSubmit={HandleAdd}>
                                        <div className="row employ-form-list">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className='col-6'>
                                                        <div className="mb-3">
                                                            <input type="text" onChange={(event) => Setaudiotitle(event.target.value)} className="form-control  bg-gray border border-0" placeholder="Audio English Title" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-6">

                                                        <div className="mb-3">
                                                            <select onChange={(event) => Setaudiotype(event.target.value)} className="form-control  bg-gray border border-0" placeholder="Type Of Audio" required>
                                                                <option value="">Select Category</option>
                                                                <option value="tatvarthasutra">Tatvartha Sutra</option>
                                                                <option value="paath">Paath</option>
                                                                <option value="samaysaar">Samay Saar</option>
                                                                <option value="strotra">Strotra</option>
                                                                <option value="bhajan">Bhajan</option>
                                                                <option value="chahdhala">Chah Dhala</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-12">
                                                        <div className=" mb-3">
                                                            <input name="audiofile" onChange={(e) => Setaudiofile(e.target.files[0])} type="file" className="form-control " id="upload-file" required
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div className='d-flex  justify-content-center align-item-center mt-3' >
                                            {
                                                loading === true ? <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Loading... </button> : <button type='submit' className='btn btn-warning font-size bg-darkyellow mx-3 px-4   ' disabled={loading}><i className="fa-regular fa-circle-check mx-2"></i>Submit</button>
                                            }
                                            <Link to={'/menu/audiolist'} className='btn  bg-black font-size text-white  mx-3 px-4 py-2 ' ><i className="fa-solid fa-xmark  mx-2"></i>Cancel</Link>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AddAudio